import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit, PLATFORM_ID} from '@angular/core';
import {RestService} from '../../services/rest.service';
import {LoadingCoordinatorService} from '../../services/loading-coordinator.service';
import {ENDPOINT} from '@shared/enum/Enum';
import {isPlatformServer} from '@angular/common';
import {ActivatedRoute} from '@angular/router';
import {APP_CONFIG, AppConfig} from "../../app-config.model";
import {finalize} from 'rxjs';

@Component({
  selector: 'app-automated-payment',
  templateUrl: './automated-payment.component.html',
  styleUrl: './automated-payment.component.scss',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutomatedPaymentComponent implements OnInit {

  showError: boolean = false;
  showSuccess: boolean = false;
  private readonly platformId = inject(PLATFORM_ID);
  private readonly configEnv = inject<AppConfig>(APP_CONFIG);
  constructor( private activatedRoute: ActivatedRoute,
               private restService: RestService,
               private cdr: ChangeDetectorRef,
               private loadingCoordinator: LoadingCoordinatorService) {  }

  ngOnInit() {
    if(isPlatformServer(this.platformId)) {return;}

    const esitoTrans = this.activatedRoute.snapshot.queryParamMap.get('ESITOTRANS_1') //this.urlService.parts();
    if (esitoTrans) {
      if (esitoTrans === '00') {
        this.showError = false;
        this.showSuccess = true;
      }
      this.showError = true;
    }
    else {

      let params = {
        'objectId':  this.activatedRoute.snapshot.queryParamMap.get('objectId'),
        'objectType': this.activatedRoute.snapshot.queryParamMap.get('objectType'),
        'origin': this.activatedRoute.snapshot.queryParamMap.get('origin'),
        'email': this.activatedRoute.snapshot.queryParamMap.get('email'),
        'selectedPaymentMode': this.activatedRoute.snapshot.queryParamMap.get('selectedPaymentMode'),
        'payPalEnabled': this.activatedRoute.snapshot.queryParamMap.get('payPalEnabled'),
        'cardStorageEnabled': this.activatedRoute.snapshot.queryParamMap.get('cardStorageEnabled'),
        'generateAliasPan': this.activatedRoute.snapshot.queryParamMap.get('generateAliasPan'),
      }

      // TODO Verificare se neccessario mappare i queryParam
      const loadingOperation = this.loadingCoordinator.begin({kind: 'page'});
      this.restService.get(this.configEnv.PRODUCTSAPI + ENDPOINT.GETPAYBYLINK, {params}).pipe(
        finalize(() => loadingOperation.finish())
      ).subscribe({
        next: (data: any) => {
          if(data.Success) {
            this.showSuccess = true;
            window.location.href = data.RedirectUrl;
          } else {
            this.showError = true;
          }
          this.cdr.detectChanges();
        }, error: (err) => {
          if (err.status === 404) {}
          this.showError = true;
          this.cdr.detectChanges();
        }
      });
    }
  }

}
